import injector from 'vue-inject'
import { storeClient } from '@/service/apiClients'

class OrderClient {
  constructor (
    requestBuilder,
    timeEstimationRequestBuilders
  ) {
    this.RequestBuilder = requestBuilder
    this.timeEstimationRequestBuilders = timeEstimationRequestBuilders
  }

  async sendNewOrder (items, orderParams, menu, storeId) {
    const request = this.RequestBuilder.build(items, orderParams, menu)
    return storeClient.post(`/stores/${storeId}/unpaidOrder`, request)
  }

  async updateOrder (items, orderParams, menu, storeId) {
    const request = this.RequestBuilder.build(items, orderParams, menu)
    return storeClient.put(`/stores/${storeId}/unpaidOrder`, request)
  }
}

injector.service('orderClient', ['requestBuilder'], OrderClient)
